import { useEffect, useRef } from "react";

type DebounceFunction<T extends unknown[]> = (...args: T) => void;

/**
 * Debounce object
 *
 * @param {() => void} callback  Callback for when the event has fired
 * @param {number} delay Delay between updates
 * @returns
 */
export const useDebounce = <T extends unknown[]>(
	callback: DebounceFunction<T>,
	delay = 250,
) => {
	const timeoutRef = useRef<NodeJS.Timeout | number | null>(null);

	useEffect(() => {
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	return (...args: T) => {
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		timeoutRef.current = setTimeout(() => {
			callback(...args);
		}, delay);
	};
};
